import { render, staticRenderFns } from "./WorkSocietySharesPanel.vue?vue&type=template&id=39be161a"
import script from "./WorkSocietySharesPanel.vue?vue&type=script&lang=js"
export * from "./WorkSocietySharesPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkSocietySharesPanel.vue?vue&type=style&index=0&id=39be161a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports